import {
	CompanyFinancialStatementTypes,
	FacilityAmortizationPeriods,
	PersonalGuaranteeTypes,
	TermSheetGovernanceTypes,
	TermSheetResponses,
	TermSheetRevision,
	TermSheetTypes,
	WarrantCoverageTypes,
} from './TermSheetRevision';
import { StructureTranches } from './TrancheEvaluation';

export interface TermSheet {
	id: number;
	guid: string;
	dataRoomGuid: string;
	bankDealProfileGuid: string;
	bankContactGuid: string;
	submittedOn: Date;
	dateReceived: Date;
	termsEffectiveDate?: Date;
	isIncumbentSolution: boolean;
	visibleToBorrower: boolean;
	lenderName: string;
	bankName: string;
	responseStatus: TermSheetResponses;
	defaultStructureTranche: StructureTranches;
	totalAmount: number;
	isExistingDebtTerms: boolean;
	revisions: TermSheetRevision[];
}

export type FacilityAvailabilityLimitTypes = keyof typeof FacilityAvailabilityLimitTypesMap;
export const FacilityAvailabilityLimitTypesMap = {
	None: 'N/A',
	EligibleAr: '% of Eligible A/R',
	MaxInventoryUsage: '% Max Usage by Inventory',
	Limit: '$ Limit',
	EligibleInventory: '% of Eligible Inventory',
	Custom: 'Custom',
};

export type CovenantTargetTypes = keyof typeof CovenantTargetTypesMap;
export const CovenantTargetTypesMap = {
	GreaterThanOrEqual: 'Greater Than or Equal',
	LessThanOrEqual: 'Less Than or Equal',
	GreaterThan: 'Greater Than',
	LessThan: 'Less Than',
	Equals: 'Equals',
};

export type RateTypes = keyof typeof RateTypesMap;
export const RateTypesMap = {
	Unknown: 'Unknown',
	Percentage: '%',
	BasisPoints: 'bps',
};

export type InterestRateTypes = keyof typeof InterestRateTypesMap;
export const InterestRateTypesMap = {
	Fixed: 'Fixed',
	Float: 'Float',
};

export type BaseRateTypes = keyof typeof BaseRateTypesMap;
export const BaseRateTypesMap = {
	Libor30Day: '30 Day Libor',
	Libor60Day: '60 Day Libor',
	Libor90Day: '90 Day Libor',
	Prime: 'Prime',
	Treasury: 'Treasury',
	Sofr: 'SOFR',
	Other: 'Other/Unknown',
};

export type TermSheetFeeTypes = keyof typeof TermSheetFeeTypesMap;
export const TermSheetFeeTypesMap = {
	Currency: '$',
	Percentage: '%',
};

export interface UpdateTermSheetRevisionDto {
	isIncumbentSolution: boolean;
	visibleToBorrower: boolean;
	termSheetType: TermSheetTypes | undefined;
	hasPersonalGuaranty: boolean;
	personalGuaranteeType: PersonalGuaranteeTypes | undefined;
	personalGuarantyDetails: string;
	warrantRequired: boolean;
	warrantAmount: number | undefined;
	isWarrantAmountTbd: boolean | undefined;
	warrantCoverageType: WarrantCoverageTypes | undefined;
	warrantPrice: number | undefined;
	isWarrantPriceTbd: boolean | undefined;
	termSheetGovernanceType: TermSheetGovernanceTypes | undefined;
	numberBoardSeats: number | undefined;
	governanceDetails: string;
	warrantDetails: string;
	sourcePage: string;
	isAccepted: number;
	borrowerNotes?: string;
	optOutLenders: boolean;
	notifyOptedOutLenders: boolean;
	notifyLender: boolean;
	termsEffectiveDate?: Date | undefined;
	reportingProvided: boolean;
	covenantsProvided: boolean;
}

export interface TermSheetReportingFormDto {
	reportingQuality: CompanyFinancialStatementTypes | undefined;
	frequency: FacilityAmortizationPeriods | undefined;
	daysToDeliver: number | undefined;
}

export interface TermSheetConditionFormDto {
	conditionTypeId: number | undefined;
	conditionText: string | undefined;
}
